export default function HeroSection() {
  const scrollToContact = () => {
    const ctaSection = document.getElementById('contact-form');
    if (ctaSection) {
      ctaSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(https://public.readdy.ai/ai/img_res/7c4699920c316dd8079902ed96de54af.jpg)`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Sell Your Hoarder House
          <span className="block text-teal-400 mt-2">No Cleanup Needed</span>
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          Tons of junk or house is non-livable? No problem - we'll buy it fast, as-is, with zero cleanup required from you
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 bg-teal-500 text-white text-lg font-semibold rounded-lg hover:bg-teal-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            Get Your Cash Offer Now
          </button>
          <a 
            href="tel:+1-915-206-5814"
            className="px-8 py-4 bg-white text-gray-900 text-lg font-semibold rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Call (915) 206-5814
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-delete-bin-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Zero Cleanup</h3>
            <p className="text-gray-700 text-sm">Leave everything behind - we handle all removal and cleanup</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Fair Cash Offer</h3>
            <p className="text-gray-700 text-sm">Get a competitive offer regardless of condition</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-xl shadow-lg">
            <div className="w-14 h-14 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">Close Fast</h3>
            <p className="text-gray-700 text-sm">Complete the sale in as little as 7 days</p>
          </div>
        </div>
      </div>
    </section>
  );
}
